document.addEventListener("DOMContentLoaded", function () {
  const heroSections = document.querySelectorAll(".homepage-hero--carousel");

  heroSections.forEach((section) => {
    const slides = Array.from(section.querySelectorAll("[data-slide]"));
    const prevBtn = section.querySelector("[data-hero-prev]");
    const nextBtn = section.querySelector("[data-hero-next]");
    const dots = Array.from(section.querySelectorAll("[data-hero-dot]"));

    if (!slides.length) return;

    let currentIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
    if (currentIndex < 0) currentIndex = 0;

    function updateSlides(index) {
      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });

      currentIndex = index;
    }

    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      updateSlides(index);
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        goToSlide(currentIndex + 1);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener("click", function () {
        const index = parseInt(dot.getAttribute("data-slide-index"), 10);
        goToSlide(index);
      });
    });

    /* Countdown logic for all countdowns inside this hero */
    const countdowns = section.querySelectorAll(".countdown[data-end]");

    countdowns.forEach((el) => {
      const raw = (el.dataset.end || "").trim();

      const match = raw.match(
        /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\+(\d{2}):(\d{2})$/
      );

      if (!match) {
        console.error("Invalid countdown datetime format:", raw);
        return;
      }

      const year = parseInt(match[1], 10);
      const month = parseInt(match[2], 10) - 1;
      const day = parseInt(match[3], 10);
      const hour = parseInt(match[4], 10);
      const minute = parseInt(match[5], 10);
      const second = parseInt(match[6], 10);
      const tzHour = parseInt(match[7], 10);
      const tzMin = parseInt(match[8], 10);

      const offsetMs = (tzHour * 60 + tzMin) * 60 * 1000;
      const endTimeUtc = Date.UTC(year, month, day, hour, minute, second) - offsetMs;

      function tick() {
        const nowUtc = Date.now();
        const diff = endTimeUtc - nowUtc;

        const daysEl = el.querySelector(".days");
        const hoursEl = el.querySelector(".hours");
        const minutesEl = el.querySelector(".minutes");
        const secondsEl = el.querySelector(".seconds");

        if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

        if (diff <= 0) {
          daysEl.innerText = "00";
          hoursEl.innerText = "00";
          minutesEl.innerText = "00";
          secondsEl.innerText = "00";
          return;
        }

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / (1000 * 60)) % 60);
        const s = Math.floor((diff / 1000) % 60);

        daysEl.innerText = String(d).padStart(2, "0");
        hoursEl.innerText = String(h).padStart(2, "0");
        minutesEl.innerText = String(m).padStart(2, "0");
        secondsEl.innerText = String(s).padStart(2, "0");
      }

      tick();
      setInterval(tick, 1000);
    });

    /* Floating item motion for active slide only */
    function animateFloatingItems() {
      const activeSlide = slides[currentIndex];
      if (!activeSlide) {
        requestAnimationFrame(animateFloatingItems);
        return;
      }

      const floatingItems = activeSlide.querySelectorAll(".floating-fruit");
      const scrollY = window.scrollY;

      floatingItems.forEach((item, index) => {
        const offset = Math.sin((scrollY + index * 60) * 0.01) * 12;
        item.style.transform = `translateY(${offset}px)`;
      });

      requestAnimationFrame(animateFloatingItems);
    }

    animateFloatingItems();

    updateSlides(currentIndex);
  });
});